import React from 'react';
import Icon from '../lib/Icon';
import Button from '../ds/Button';

/** Shown when a non-coach reaches an individual results URL directly. */
export default function LockedResults({ onBack }) {
  return (
    <div style={{ padding: '90px 36px', maxWidth: 600, margin: '0 auto', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div style={{
        display: 'inline-flex', width: 66, height: 66, alignItems: 'center', justifyContent: 'center',
        borderRadius: 'var(--radius-lg)', background: 'var(--human-50)', color: 'var(--human-600)', marginBottom: 22,
      }}>
        <Icon name="users" size={28} />
      </div>
      <h1 style={{ margin: '0 0 12px', fontSize: 'var(--text-h3)' }}>Individual results stay with the coach</h1>
      <p style={{
        margin: '0 0 26px', fontFamily: 'var(--font-serif)', fontSize: 'var(--text-base)',
        color: 'var(--ink-soft)', lineHeight: 'var(--lh-body)', textWrap: 'pretty', maxWidth: '48ch',
      }}>
        Coachability is a developmental measure. A participant's individual scores go only to their independent
        CCI coach — keeping them private is what makes people candid, and candor is what makes the cohort data
        worth trusting. As the program owner you still see aggregate team results and participation status.
      </p>
      <Button variant="outline" size="sm" iconLeft={<Icon name="arrowLeft" size={15} />} onClick={onBack}>
        Back to report
      </Button>
    </div>
  );
}
